import Vue from 'vue'
import store from '@/store/'
import VueI18n from 'vue-i18n'

// add plugin to Vue
Vue.use(VueI18n)

// Create VueI18n instance with options
// English is the complete set; other locales only translate part of it, so a key missing from
// them falls back to English instead of rendering as its key path.
const FALLBACK_LOCALE = 'en'

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: FALLBACK_LOCALE,
  silentFallbackWarn: true, // partial locales fall back on purpose
  messages: {}, // set locale messages
})

async function ensureMessages(locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    const messages = await import(/* webpackChunkName: "lang/[request]" */ '@/lang/' + locale)
    i18n.setLocaleMessage(locale, messages)
  }
}

// async change locale
export async function loadMessages(locale) {
  await ensureMessages(locale)

  if (locale !== FALLBACK_LOCALE) {
    await ensureMessages(FALLBACK_LOCALE)
  }

  if (i18n.locale !== locale) {
    i18n.locale = locale
  }
}

// local initial setup
;(async function () {
  await loadMessages(store.getters['lang/locale'])
})()

export default i18n
